import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Title } from '@/ui/text/title/Title'

export type AddressTitleProps = UiComponentProps & {
  /** The address title */
  name?: string | null
}

export function AddressTitle({ name: title, 'data-testid': dataTestid }: AddressTitleProps) {
  const { t } = useTranslation(['address'])

  return (
    <Title as="h6" data-testid={`${dataTestid}/title`} size="md" lineHeight="light">
      {title ?? t('address:title')}
    </Title>
  )
}
